// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/gyro-preflight-checks.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/gyro-preflight-checks/gyro-preflight-checks.js';

mount([g0]);
